'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Heading_Heading = require('../Heading/Heading.cjs.js');
require('../../../utils/heading-level-context/HeadingLevelContext.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const tableTitleArea = "_table-title-area_10lid_1";
const title = "_title_10lid_10";
const styles = {
	tableTitleArea: tableTitleArea,
	title: title
};

const TableTitle = (props) => {
  return React__default.default.createElement(components_display_Heading_Heading.Heading, { className: styles.title }, props.children);
};
const TableTitleArea = ({ children, kind = "standard" }) => {
  return React__default.default.createElement("header", { className: styles.tableTitleArea, "data-kind": kind, "data-zds": true }, children);
};

exports.TableTitle = TableTitle;
exports.TableTitleArea = TableTitleArea;
//# sourceMappingURL=TableTitleArea.cjs.js.map
